module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/arrow-17c5f30cdc547c44557a5a75e614dfa7.svg&quot;;"